import { getApiBaseUrl } from '../../utils/api';

interface AuthMeResponse {
  user?: {
    is_admin?: boolean;
  };
}

/**
 * Resolve effective admin authorization from the backend source of truth.
 */
export async function fetchDatabaseAdminFlag(accessToken: string): Promise<boolean | null> {
  if (!accessToken) {
    return null;
  }

  try {
    const response = await fetch(`${getApiBaseUrl()}/auth/me`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      return null;
    }

    const authMeResponse = (await response.json()) as AuthMeResponse;
    return Boolean(authMeResponse.user?.is_admin);
  } catch (error) {
    console.error('Failed to fetch effective admin authorization:', error);
    return null;
  }
}
